// extracted by mini-css-extract-plugin
export default {"labelWithAssigneeWrapper":"OptionsWithAssignee_labelWithAssigneeWrapper__prgbq"};